import APIService from './APIService';

export default {
  getAlgoritmosAtivos() {
    return APIService.apiCall().get('setorizacoes/algoritmos/get-ativos');
  }
};
